import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiArrowRight, FiDownload } from 'react-icons/fi';
import '../styles/WelcomePage.css';
import dexLogo from '../assests/DexWallet Logo Symbol.png';

const WelcomePage = () => {
  const navigate = useNavigate();

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.8, staggerChildren: 0.15 }
    }
  };

  const itemUpVariants = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 50, damping: 20 }
    }
  };

  return (
    <div className="welcome-page">
      {/* Background Layer */}
      <div className="welcome-background">
        <div className="aurora-container">
          <div className="aurora-blob aurora-1" />
          <div className="aurora-blob aurora-2" />
          <div className="aurora-blob aurora-3" />
        </div>
        <div className="grid-overlay" />
      </div>

      <motion.div
        className="content-wrapper"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        {/* Helper layout for Desktop: Left Side / Mobile: Top Side */}
        <div className="hero-section">
          <motion.div className="logo-display" variants={itemUpVariants}>
            <img src={dexLogo} alt="DexWallet Logo" />
          </motion.div>

          <motion.h1 className="brand-title" variants={itemUpVariants}>
            DexWallet
          </motion.h1>

          <motion.p className="brand-subtitle" variants={itemUpVariants}>
            The Future of DeFi is Here
          </motion.p>

          <motion.p className="brand-desc" variants={itemUpVariants}>
            Experience lightning-fast, secure transactions on TON and BNB chains.
            No intermediaries, just you and your assets.
          </motion.p>
        </div>

        {/* Helper layout for Desktop: Right Side / Mobile: Bottom Sheet */}
        <motion.div className="action-sheet" variants={itemUpVariants}>
          <button
            className="crystal-button btn-primary"
            onClick={() => navigate('/create-wallet')}
            aria-label="Create New Wallet"
          >
            <span>Create New Wallet</span>
            <FiArrowRight />
            <div className="btn-shine" />
          </button>

          <button
            className="crystal-button btn-glass"
            onClick={() => navigate('/import-wallet')}
            aria-label="Import Wallet"
          >
            <span>Import Existing Wallet</span>
            <FiDownload />
          </button>

          <p className="legal-text">
            By continuing, you agree to our <a href="#">Terms</a> & <a href="#">Privacy</a>
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default WelcomePage;
